
import {mapGetters} from "vuex";
import {pushmap} from "../router/pushmap";

const mixin={
  computed:{
    ...mapGetters(['apiList','menuList']),

  },

  created() {
    if (this.$route && this.$route.params.targetTab) {
      this.current=this.$route.params.targetTab
    }

  },
  activated(){
    if (this.$route && this.$route.params.targetTab) {
      this.current=this.$route.params.targetTab
    }

  },
  methods:{
    routerGo(params){
      if(!pushmap[params.name]){
        this.$router.push(params)
      }
      else {
        let obj=pushmap[params.name]
        let trans={
          ...params,
          name:obj.to,
        }
        if(obj.targetTab) {
          !trans.params && (trans.params = {})
          trans.params.targetTab=obj.targetTab
        }
        this.$router.push(trans)

      }

    },
    mp(menu){
      if(this.menuList&& this.menuList.indexOf(menu)!==-1){
        return true

      }
      return false


    },
    p(api) {
      function getType(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1)
      }
      if(!api){
        return true
      }

      if (!this.apiList || !this.apiList.length) {
        return false
      }
      let hasPermission = false;
      if(getType(api)==='Array'){
        for(let i=0,len=api.length;i<len;i++){
          if(this.apiList.indexOf(api[i])!==-1){
            hasPermission=true;
            break;
          }
        }
      }
      if(getType(api)==='String'){
        if(this.apiList.indexOf(api)!==-1){
          hasPermission=true
        }
      }

      return hasPermission

    },


  }

}

export {mixin}
